<template>
    <div :class="{
          removed,
        }"
         class="attachment-group">
        <div :class="{ 'can-download': canDownload }" class="header" @click="onDownload">
            <IconFolder class="icon" />

            <div class="info">
                <span class="name">{{ title }}</span>

                <div class="params">
                    <span class="type">Папка</span>
                    <span class="circle-marker"></span>
                    <span class="size">{{ sizeDocuments }}</span>
                    <span class="circle-marker"></span>
                    <span class="documents-length">
                        {{ documentsLength | pluralForm([ '%n документ', '%n документа', '%n документов' ]) }}
                    </span>
                </div>
            </div>

            <div class="action-list">
                <template v-if="!emptyDocuments">
                    <button :class="{ open }" class="toggle only-icon no-border"
                            @click.stop="open = !open">
                        <IconChevronDown class="icon" />
                    </button>
                </template>

                <div class="badges">
                    <template v-if="removed">
                        <div class="item error">Удалено</div>
                    </template>
                </div>

                <button v-show="canRestore && removed"
                        class="item restore only-icon no-border"
                        @click.stop="$emit('restore')">
                    <IconUndoLarge class="icon" />
                </button>
                <TooltipOld bind-to=".item.restore" class="tooltip hint" trigger-on="hover">
                    Восстановить
                </TooltipOld>

                <button v-if="actions" class="action only-icon no-border action-menu">
                    <IconMenu class="icon" />
                </button>

                <TooltipOld v-if="actions"
                            ref="actionMenuTooltip"
                            bind-to=".action-list .action-menu"
                            class="tooltip inform menu small"
                            trigger-on="click">

                    <button v-if="canEdit && !removed"
                            class="item iconed no-border"
                            @click.stop="$emit('edit'); $refs.actionMenuTooltip.close()">
                        <IconEditLarge class="icon" />
                        <span class="text">Редактировать</span>
                    </button>

                    <button v-if="canRemove && !removed"
                            class="item remove iconed no-border"
                            @click.stop="onRemove">
                        <IconTrashLarge class="icon" />
                        <span class="text">Удалить</span>
                    </button>
                </TooltipOld>

                <checkbox v-if="canSelect"
                          v-model="checked"
                          class="checkbox"
                          @change="onInput" />
            </div>
        </div>

        <Transition name="slide-top">
            <div v-if="open" class="documents-list">
                <AttachmentInfo v-for="(it, id) in documents"
                                :key="id"
                                :can-edit="canEditAttachment"
                                :loading="it.loading"
                                :removed="it.removed || false"
                                :value="toDocument(it)"
                                class="attachment"
                                @download="$emit('download', it)"
                />
            </div>
        </Transition>
    </div>
</template>

<script>
import IconMenu from '@/common/comp/attachment/icons/menu.svg';
import IconChevronDown from './icons/chevron_down.svg?component';
import IconFolder from './icons/folder.svg?component';
import IconUndoLarge from './icons/undo_large.svg?component';

import { formatFileSize } from '@/common/page_comp/Documents/fileApi.js';
import { showConfirm } from '@dsee/components/popups/confirm.js';
import DocumentGroup from '@/common/page_comp/Documents/documentGroup.js';


export default {
    name: 'AttachmentGroup',
    components: {
        IconMenu,
        IconChevronDown,
        IconFolder,
        IconUndoLarge,
    },
    props: {
        value: {
            type: [ Object, DocumentGroup ],
        },
        toDocument: {
            type: Function,
            default: (it) => it.value,
        },
        /**
         * Группа удалена
         */
        removed: {
            type: Boolean,
            default: false,
        },
        /**
         * Можно удалить
         */
        canRemove: {
            type: Boolean,
            default: false,
        },
        /**
         * Можно восстановить группу
         */
        canRestore: {
            type: Boolean,
            default: false,
        },
        /**
         * Можно скачать группу
         */
        canDownload: {
            type: Boolean,
            default: false,
        },
        /**
         * Можно редактировать группу
         */
        canEdit: {
            type: Boolean,
            default: false,
        },
        /**
         * Можно редактировать файл
         */
        canEditAttachment: {
            type: Boolean,
            default: false,
        },
        /**
         * Можно выбрать файл
         */
        canSelect: {
            type: Boolean,
            default: false,
        },
        /**
         * Заблокировать редактирование
         */
        disabledEdit: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            open: false,
            checked: false,
        };
    },
    computed: {
        title() {
            if (this.value instanceof DocumentGroup)
                return this.value.value.name;

            return this.value.name;
        },
        documentsLength() {
            if (this.value instanceof DocumentGroup)
                return this.value.value.documents.length;

            return this.value.documents.length;
        },
        sizeDocuments() {
            let size = 0;
            if (this.value instanceof DocumentGroup) {
                size = this.value.value.documents.reduce((acc, it) => acc + it.value.size, 0);
            } else {
                size = this.value.documents.reduce((acc, it) => acc + it.size, 0);
            }
            return formatFileSize(size);
        },
        actions() {
            if (this.removed)
                return false;

            return this.canRemove || this.canRestore || this.canEdit || this.canSelect;
        },
        emptyDocuments() {
            if (this.value instanceof DocumentGroup)
                return this.value.value.documents.length === 0;

            return this.value.documents.length === 0;
        },
        documents() {
            if (this.value instanceof DocumentGroup)
                return this.value.value.documents;

            return this.value.documents;
        },
    },
    methods: {
        onDownload() {
            if (this.removed)
                return;

            this.$emit('downloadGroup');
        },
        onInput($event) {
            const data = this.value;
            data.checked = true;
        },
        async onRemove() {
            const resp = await showConfirm({
                title: 'Подтвердите удаление папки',
                text: 'Папка будет удалена вместе с содержимым',
                buttons: [
                    {
                        title: 'Удалить',
                        value: 1,
                        class: 'primary',
                    }, {
                        title: 'Отмена',
                        value: 0,
                    },
                ],
            });
            if (!resp)
                return;

            this.$emit('remove');
        },
    },
};
</script>

<style lang="scss" scoped>
.attachment-group {
    user-select: none;
    box-sizing: border-box;
    width: 100%;

    .header {
        display: flex;
        align-items: center;
        column-gap: 12px;

        &.can-download {
            cursor: pointer;
        }

        & > .icon {
            flex: none;
            display: flex;
            align-items: center;
            margin: 0;
            opacity: .7;
        }

        .toggle {
            &.open > .icon {
                transform: rotate(180deg);
            }
        }
    }

    &.removed {
        .info {
            .name,
            .params {
                color: var(--button-secondary-disabled-color);
            }
        }

        .header > .icon {
            opacity: .25;
        }

        .documents-list {
            opacity: .25;
        }
    }

    .info {
        display: inline-grid;
        flex-direction: column;
        flex-grow: 2;
        max-width: 100%;
        overflow: hidden;

        .name {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            margin-bottom: 2px;
            transition: var(--transition-function);
        }

        .params {
            display: flex;
            align-items: center;
            width: 100%;
            overflow: hidden;
            color: var(--label-color);
            font-size: 12px;
            line-height: 16px;
            transition: var(--transition-function);

            .type {
                flex: none;
            }

            .size {
                flex: none;
            }

            .circle-marker {
                width: 2px;
                height: 2px;
                background-color: var(--label-color);
                margin: 0 6px;
            }

            .type {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }
    }

    .action-list {
        display: inline-flex;
        align-items: center;
        column-gap: 16px;
    }

    .documents-list {
        margin-left: 34px;

        .attachment {
            margin-top: 20px;
        }
    }

    .attachment {

    }

    .attachment + .attachment {
        margin-top: 20px;
    }
}

.tooltip.inform.menu {
    max-width: 232px;
    width: 100%;

    .item {
        width: 100%;
        font-weight: 500;

        &:not( :last-child) {
            margin-bottom: 14px;
        }

        .icon {
            color: rgba(131, 137, 151, 1);
        }
    }

    .move-menu {
        .chevron {
            margin: 0;
        }
    }
}
</style>
